export default "data:video/mp2t;base64,Ly8vIDxyZWZlcmVuY2UgdHlwZXM9InJlYWN0LXNjcmlwdHMiIC8+Cg=="